<template>
    <v-dialog
      v-model="isSuccessed"
      persistent
      max-width="550"
    >
      <v-card>
         <v-card-text class="text-center">
           <div><v-icon class="my-5" color="teal darken-1" x-large>mdi-checkbox-marked-circle</v-icon></div>
           <p v-html="successText"></p>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="amber darken-1"
            rounded
            block
            @click="showDialog()"
            class="black--text mb-5"
          >
            <v-icon class="mr-2">mdi-cup-water x-large</v-icon>続けてサンプルを登録する
          </v-btn>
        </v-card-actions>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="amber darken-1"
            rounded
            block
            @click="gotoApplication()"
            class="black--text mb-5"
          >
            <v-icon class="mr-2">mdi-plus</v-icon>{{category}}の分析を依頼する
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
export default {
    props:["successUrl","successText", "category"],
    data: () => ({
        isSuccessed: false,
        buttonName: ''
    }),
    methods: {
/*
      showApplication() {
          this.isSuccessed = false
          this.$router.push("/application")
      },
*/
      gotoApplication: function() {
//        let AnalizeTypeGroup = this.$store.state.operatingCompany.AnalizeTypeGroup
        console.log("依頼する区分:", this.category)
        this.$router.push("/application?category=" + this.category)
        this.isSuccessed = false
      },
      showDialog() {
          this.isSuccessed = false
//          this.$router.push(this.successUrl)
          this.$router.back()
      },
      open() {
        this.isSuccessed = true
      }
    }
}
</script>

